import { forwardRef } from 'react';

import { Button } from '../Button';
import type { IconButtonProps } from './types';

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ icon: Icon, iconProps, ...props }, ref) => {
    return (
      <Button ref={ref} {...props}>
        <div className="ods-aspect-square ods-h-full ods-flex ods-items-center ods-justify-center">
          <Icon {...iconProps} />
        </div>
      </Button>
    );
  }
);
